// extracted by mini-css-extract-plugin
export var currencyInput = "_m4-1";
export var currencySymbol = "_m4-0";